module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a8BXU"))).then(() => module.bundle.root('jnagv'));